import { Link as BlueprintLink } from '@box/blueprint-web';
import BuieLink from 'box-ui-elements/es/components/link/Link';
import React from 'react';
import { useShouldRenderBlueprint } from '../../../common/useShouldRenderBlueprint';
import VariantComponent from '../../../common/variant-component';

/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const Link = (props: any) => {
  // Should be addressed in FORMS-21241
  const shouldRenderBlueprint = useShouldRenderBlueprint();
  return (
    <VariantComponent
      NewComponent={BlueprintLink}
      OldComponent={BuieLink}
      shouldRenderNewComponent={shouldRenderBlueprint}
      {...props}
    />
  );
};

export default Link;
